export const localeDomains = (locale: string) => {
  if (process.env.NEXT_PUBLIC_WAMAZING_ENV !== 'production') {
    switch (locale) {
      case 'zh_tw':
        return 'https://tw.staging-wamazing.com';
      case 'zh_hk':
        return 'https://hk.staging-wamazing.com';
      case 'zh_cn':
        return 'https://staging.wamazing-cn.com';
      case 'en':
        return 'https://www.staging-wamazing.com';
      case 'ja':
        return 'https://jp.staging-wamazing.com';
      default:
        return 'https://www.staging-wamazing.com';
    }
  }
  switch (locale) {
    case 'zh_tw':
      return 'https://tw.wamazing.com';
    case 'zh_hk':
      return 'https://hk.wamazing.com';
    case 'zh_cn':
      return 'https://p.wamazing-cn.com';
    case 'en':
      return 'https://www.wamazing.com';
    case 'ja':
      return 'https://jp.wamazing.com';
    default:
      return 'https://www.wamazing.com';
  }
};
